import { useSyncExternalStore } from 'react';

// Keep workspace identity unknown across the old request and its fresh read.
// Plain module state (no store import), so pickers read it without Redux.
const pendingRefreshes = new Map<string, number>();
const refreshListeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
  refreshListeners.add(listener);
  return () => {
    refreshListeners.delete(listener);
  };
};

export function updatePendingRefreshes(organizationId: string, delta: number) {
  const count = (pendingRefreshes.get(organizationId) ?? 0) + delta;
  if (count > 0) pendingRefreshes.set(organizationId, count);
  else pendingRefreshes.delete(organizationId);
  refreshListeners.forEach((listener) => listener());
}

export function useAttioConnectionRefreshing(organizationId: string) {
  return useSyncExternalStore(subscribe, () =>
    pendingRefreshes.has(organizationId)
  );
}
